<script>
  export let title;
  export let subtitle;
</script>

<div class="relative mb-16">
  <div class="relative flex justify-center">
    <div class="text-center">
      <!-- Glassmorphic line -->
      <div class="w-24 h-[2px] mx-auto mb-6 bg-gradient-to-r from-transparent via-white/30 to-transparent backdrop-blur-sm rounded-full"></div>
      
      <!-- Title with animated gradient -->
      <h1
        class="text-5xl md:text-6xl font-bold text-transparent bg-clip-text
        bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 mb-4
        animate-gradient-x bg-[length:200%_auto]"
      >
        {title}
      </h1>

      <!-- Subtitle with decorative elements -->
      <div
        class="flex items-center justify-center gap-4 text-gray-600 dark:text-gray-400"
      >
        <!-- Left line with dot -->
        <div class="flex items-center gap-2">
          <span
            class="w-12 h-[1px] bg-gradient-to-r from-transparent via-gray-400 dark:via-gray-500 to-transparent"
          ></span>
          <span class="w-1 h-1 rounded-full bg-blue-500"></span>
        </div>

        <!-- Subtitle text -->
        <p class="text-sm md:text-base font-medium tracking-wide">
          {subtitle}
        </p>

        <!-- Right line with dot -->
        <div class="flex items-center gap-2">
          <span class="w-1 h-1 rounded-full bg-pink-500"></span>
          <span
            class="w-12 h-[1px] bg-gradient-to-r from-transparent via-gray-400 dark:via-gray-500 to-transparent"
          ></span>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  @keyframes gradient-x {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }

  .animate-gradient-x {
    animation: gradient-x 15s ease infinite;
  }
</style> 